export const drawerComponentOverrides = {
    MuiDrawer: {
        styleOverrides: {
            paperAnchorBottom: {
                '&:has(.MuiStepper-root)': {
                    padding: '1rem',
                    borderRadius: '1rem 1rem 0 0'
                }
            }
        }
    }
};
